module.exports = "#version 100\r\nprecision highp float;\r\n\r\nattribute vec3 a_position;\r\n\r\nvarying vec2 v_uv;\r\n\r\nvoid main() {\r\n    gl_Position = vec4(a_position, 1.0);\r\n    v_uv = a_position.xy * 0.5 + 0.5;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/quad.vert.glsl
// module id = 11
// module chunks = 0